import { combineReducers } from 'redux';

import balance from './balance/reducers';
import campaignEditor from './campaign-editor/reducers';
import discussion from './comments/reducers';
import contentfulCreatives from './creative-assets/ContentfulCreatives/reducers';
import creativeAssets from './creative-assets/reducers';
import { reducer as changeGuard } from './generic/change-guard';
import { reducer as flashMessages } from './generic/flash-messages';
import isRequestInProgress from './generic/request-in-progress/reducer';
import mediaSetRequirements from './media-set-requirements/reducer';
import merchants from './merchants/reducer';
import products from './products/reducer';
import quoteEditor from './quote-editor/reducers';
import users from './users/reducer';
import createStore from './utils/create-store';

/*
  For now, this store is available globally, because we have some global functions,
  such as flash, where we need access to the store
 */

function createGlobalStore() {
  const reducers = combineReducers({
    flashMessages,
    changeGuard,
    creativeAssets,
    balance,
    discussion,
    quoteEditor,
    campaignEditor,
    products,
    merchants,
    mediaSetRequirements,
    users,
    isRequestInProgress,
    contentfulCreatives,
  });
  const initialState = {};
  return createStore(reducers, initialState, []);
}

export default createGlobalStore();
export { createGlobalStore }; // for stories and tests
